import src from "IMAGE";
export default { src, width: 300, height: 88, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AJaWlVabm5lQqqqoXampqGatsbBrqbCxfaCsroFpbmIxAEVEQxY7OzoQSUlIG0lJRxpren1TlrS5pZqwnqPJxW6fHYUe4k547oEAAAAASUVORK5CYII="};
